import React from 'react';
import Input from "components/form/Input";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import GModal from "components/ui/modal/Modal";
import GButton from "components/ui/button/Button";
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getinventoryCostAnalysisFilteredData } from '../services/inventoryCostAnalysisServices';

export default function FilterModal({onClose , data }) {
    const { t } = useTranslation();
    const dispatch =useDispatch();
    const toast = useToast({position: "top", duration: 3000, status: "success", });

    const [filteredData, setFilteredData] = useState(data);

    // Filter Data
    const [filterCriteria, setFilterCriteria] = useState({
        Items: ""
      });

      const handleFilterInventoryCategories = (e) => {
        e.preventDefault();
    
        const filteredResult = data.filter((item) => {
          const { Items } = filterCriteria;
    
          let filterItems = true;
    
          if (Items) {
            filterItems = item?.ProductName?.toLowerCase().includes(Items.toLowerCase());
          }

          return (
            filterItems
          );

        });
    
        setFilteredData(filteredResult);
        onClose();
        dispatch(getinventoryCostAnalysisFilteredData(filteredResult));
      };

  return <>
  
  <GModal
      onClose={onClose}
      modalHeader={t("pages.reports.analysis_reports.inventory_cost_analysis")}
      modalContent={
        <Box p={4}>
          <form 
            onSubmit={handleFilterInventoryCategories}
          >
            <Stack spacing={6}>
              <Input
                label={t("pages.reports.reports_tables.items")}
                labelStyle={{ textTransform: "capitalize" }}
                placeholder={t("pages.reports.reports_tables.product")}
                name="Items"
                value={filterCriteria.Items}
                onChange={(e) =>
                  setFilterCriteria({
                    ...filterCriteria,
                    Items: e.target.value,
                  })
                }
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  
  </>
};